module.exports = __webpack_public_path__ + "img/Weapon_284.b7af1120.png";